import FormattedMessage from 'I18n/components/FormattedMessage';
import PropTypes from 'prop-types';
import { useCallback, useState } from 'react';
import UIButton from 'UIComponents/button/UIButton';
import UIDialogBody from 'UIComponents/dialog/UIDialogBody';
import UIDialogCloseButton from 'UIComponents/dialog/UIDialogCloseButton';
import UIDialogFooter from 'UIComponents/dialog/UIDialogFooter';
import UIDialogHeader from 'UIComponents/dialog/UIDialogHeader';
import UIModal from 'UIComponents/dialog/UIModal';
import H2 from 'UIComponents/elements/headings/H2';
import UIForm from 'UIComponents/form/UIForm';
import UIRadioInput from 'UIComponents/input/UIRadioInput';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const Actions = {
  EDIT: 'edit',
  DELETE: 'delete'
};
export default function RepeatingTaskModal({
  onClose,
  onDecisionMade,
  action
}) {
  const [shouldUpdateTemplate, setShouldUpdateTemplate] = useState(false);
  const handleSubmit = useCallback(evt => {
    evt.preventDefault();
    onDecisionMade({
      updateTemplate: shouldUpdateTemplate,
      stopRepeating: shouldUpdateTemplate
    });
  }, [onDecisionMade, shouldUpdateTemplate]);
  const setTrue = useCallback(() => {
    setShouldUpdateTemplate(true);
  }, []);
  const setFalse = useCallback(() => {
    setShouldUpdateTemplate(false);
  }, []);
  return /*#__PURE__*/_jsx(UIModal, {
    use: action === Actions.DELETE ? 'danger' : 'conversational',
    width: 500,
    children: /*#__PURE__*/_jsxs(UIForm, {
      onSubmit: handleSubmit,
      children: [/*#__PURE__*/_jsxs(UIDialogHeader, {
        children: [/*#__PURE__*/_jsx(H2, {
          children: action === Actions.DELETE ? /*#__PURE__*/_jsx(FormattedMessage, {
            message: "taskFormsLib.repeatingTaskModal.deleteHeader"
          }) : /*#__PURE__*/_jsx(FormattedMessage, {
            message: "taskFormsLib.repeatingTaskModal.editHeader"
          })
        }), /*#__PURE__*/_jsx(UIDialogCloseButton, {
          onClick: onClose
        })]
      }), /*#__PURE__*/_jsxs(UIDialogBody, {
        children: [/*#__PURE__*/_jsx("p", {
          children: action === Actions.DELETE ? /*#__PURE__*/_jsx(FormattedMessage, {
            message: "taskFormsLib.repeatingTaskModal.deleteMessage"
          }) : /*#__PURE__*/_jsx(FormattedMessage, {
            message: "taskFormsLib.repeatingTaskModal.editMessage"
          })
        }), /*#__PURE__*/_jsx(UIRadioInput, {
          name: "repeating-task-modal",
          onChange: setFalse,
          checked: !shouldUpdateTemplate,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "taskFormsLib.repeatingTaskModal.options.onlyThisTask"
          })
        }), /*#__PURE__*/_jsx(UIRadioInput, {
          name: "repeating-task-modal",
          onChange: setTrue,
          checked: shouldUpdateTemplate,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "taskFormsLib.repeatingTaskModal.options.allFutureTasks"
          })
        })]
      }), /*#__PURE__*/_jsxs(UIDialogFooter, {
        align: "center",
        children: [/*#__PURE__*/_jsx(UIButton, {
          use: action === Actions.DELETE ? 'danger' : 'primary',
          type: "submit",
          children: action === Actions.DELETE ? /*#__PURE__*/_jsx(FormattedMessage, {
            message: "taskFormsLib.repeatingTaskModal.confirmDelete"
          }) : /*#__PURE__*/_jsx(FormattedMessage, {
            message: "taskFormsLib.repeatingTaskModal.confirmEdit"
          })
        }), /*#__PURE__*/_jsx(UIButton, {
          onClick: onClose,
          use: action === Actions.DELETE ? 'tertiary-light' : 'secondary',
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "taskFormsLib.repeatingTaskModal.cancel"
          })
        })]
      })]
    })
  });
}
RepeatingTaskModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  onDecisionMade: PropTypes.func.isRequired,
  action: PropTypes.oneOf(Object.values(Actions)).isRequired
};